import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';

import { SummaryInvestmentAssetMaterialModel } from '../../models/summary-investment-asset-material.model';
import { InvestmentAssetMaterialActions, InvestmentAssetMaterialActionTypes, LoadInvestmentAssetMaterialsSuccess } from '../actions/investment-asset-material.actions';


export interface InvestmentAssetMaterialState {
  items: SummaryInvestmentAssetMaterialModel[];
  total: number;
  res: PaginableResponseModel<SummaryInvestmentAssetMaterialModel>;
  selected: SingleResponseModel<SummaryInvestmentAssetMaterialModel> | null;
  loading: boolean;
  error: any
}


export const initalState: InvestmentAssetMaterialState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function InvestmentAssetMaterialReducer(
  state = initalState,
  action: InvestmentAssetMaterialActions
): InvestmentAssetMaterialState {

  switch (action.type) {
    case InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterials:
      return { ...state, loading: true, error: null };

    case InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialsSuccess:
      const { items, total } = (action as LoadInvestmentAssetMaterialsSuccess).payload;
      return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,
           };
    case InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialsFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
